define('lib/Podio.UI.SimpleInlineEdit',['require','underscore','jquery','lib/backbone/Backbone.PodioView'],function (require) {
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');

  return PodioView.extend({
    podioEvents: {
      "click .view":       "onViewClicked",
      "blur .edit":        "onEditBlurred",
      "keyup .edit input": "onKeyup",
    },

    initialize: function(options) {
      _.bindAll(this, "onViewClicked", "onEditBlurred", "onKeyup");

      this.callback     = options.callback;
      this.elm          = options.elm;
      this.currentValue = $.trim(this.elm.text());

      this.elm.addClass("simple-inline-editable")
              .wrapInner("<div class='view' />");


      this.viewElm = this.elm.find(".view");
      this.editElm = (options.editElm || $("<input type='text' />"))
                       .val(this.currentValue)
                       .hide()
                       .appendTo(this.elm);

      this.editElm.wrap("<div class='edit' />");

      this._super();
    },

    onViewClicked: function(elmTarget, event) {
      this._switchToEditMode();
    },

    onEditBlurred: function(elmTarget, event) {
      this._switchToViewMode();
      this._triggerCallbackIfChanged();
    },

    onKeyup: function(elmTarget, event) {
      if(event.keyCode == 13) {
        this._switchToViewMode();
        this._triggerCallbackIfChanged();
      }
    },

    _switchToEditMode: function() {
      this.viewElm.hide();
      this.editElm.show().focus().select();
    },

    _switchToViewMode: function() {
      this.editElm.hide();
      this.viewElm.show();
    },

    _triggerCallbackIfChanged: function() {
      if(this.editElm.val() != this.currentValue) {
        this.currentValue = this.editElm.val();
        this.callback.call(this, this.currentValue);
      }
    },
  });
});

